import { ResponseData, createAbortableRequestPromise, stringify, transformArguments } from '../abortable-promise';
import { PanelSettings } from './types';

export class Panel {
  constructor(private settings: PanelSettings) { }

  createPanelRequest() {
    const query = stringify(transformArguments({
      ...this.settings.args,
      market: this.settings.market,
      customerKey: this.settings.customerKey,
      sessionKey: this.settings.sessionKey
    }));

    return createAbortableRequestPromise('GET', `${this.settings.url}/panels${this.settings.path}?${query}`);
  }
}
